import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api";
import { setEmployeeSession } from "../auth";

const Login = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/payslips";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/employee/auth/login", form);
      setEmployeeSession(res.data.token, res.data.employee);
      navigate(from, { replace: true });
    } catch (err) {
      console.error(err);
      setError("Invalid username or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-fullpage">
      <div className="login-split">
        <div className="login-hero-panel">
          <div className="login-hero-overlay">
            <img src="/logo.png" alt="Quantumnique logo" className="login-hero-logo" />
            <h2 className="login-hero-title">Quantumnique Solutions</h2>
            <p className="login-hero-text">
              Welcome back to QDesk. Access your payslips, daily sheets, and updates.
            </p>
          </div>
        </div>

        <div className="login-card">
          <div className="login-card-header">
            {/* <div className="login-logo-circle">QS</div> */}
            <div className="login-logo-big">
              <img src="/logo.png" alt="Quantumnique logo" className="login-logo-img" />
            </div>
            <div>
              <h1 className="login-title">QDesk Employee Login</h1>
              <p className="login-subtitle">
                Secure access to your dashboard and payslips.
              </p>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="field-label">Username</label>
              <input
                className="field-input"
                value={form.username}
                onChange={(e) =>
                  setForm({ ...form, username: e.target.value })
                }
                placeholder="your email"
              />
            </div>
            <div className="field" style={{ marginTop: 12 }}>
              <label className="field-label">Password</label>
              <input
                className="field-input"
                type="password"
                value={form.password}
                onChange={(e) =>
                  setForm({ ...form, password: e.target.value })
                }
                placeholder="••••••••"
              />
            </div>
            {error && <div className="login-error">{error}</div>}
            <button
              type="submit"
              className="btn-primary-large login-submit-btn"
              disabled={loading}
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
